import { useEffect, useState } from 'react';
import { subscribeIntegrationInbox, type IntegrationInboxItem } from '@/services/integrations/integrations';

/**
 * Fila "Exames sem paciente" (spec 022) ao vivo. `enabled = false` (papel
 * sem acesso) não assina nada — as regras negariam a leitura de qualquer jeito.
 */
export function useIntegrationInbox(clinicId: string | null | undefined, enabled = true) {
  const [items, setItems] = useState<IntegrationInboxItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!clinicId || !enabled) {
      setItems([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    return subscribeIntegrationInbox(
      clinicId,
      (list) => {
        setItems(list);
        setError(null);
        setLoading(false);
      },
      (err) => {
        console.warn('[integracoes] falha ao ler a fila de exames', err);
        setError('Não foi possível carregar a fila.');
        setLoading(false);
      },
    );
  }, [clinicId, enabled]);

  return { items, loading, error };
}
